<template>
	<div class="wrapper">
		<!-- 标题区域 -->
		<div class="page-header">
			<div class="header-content">
				<h2 class="page-title">
					<i class="el-icon-cpu title-icon"></i>
					{{ $route.meta.name }}
				</h2>
			</div>
		</div>

		<!-- 表单区域 -->
		<el-card class="form-card" shadow="never">
			<div class="card-header-title">
				<i class="el-icon-edit-outline"></i>
				<span>计算参数</span>
			</div>
			<el-form :model="form" label-width="120px" :rules="rules" ref="form" class="calculate-form">
				<el-form-item label="售价" prop="salePrice">
					<el-input-number
						v-model="form.salePrice"
						placeholder="请输入售价"
						:controls="false"
						:min="0"
						:precision="2"
						class="form-input-number"
					/>
					<span class="form-tip">单位：元</span>
				</el-form-item>
				<el-form-item label="租期" prop="billNum">
					<el-select
						v-model="form.billNum"
						placeholder="请选择租期"
						class="form-select"
						@change="onBillNumChange"
					>
						<el-option
							v-for="item in billNumOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="方案选择" prop="storeComboId">
					<el-select
						v-model="form.storeComboId"
						placeholder="请选择方案"
						class="form-select"
					>
						<el-option
							v-for="item in filteredComboOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						/>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button 
						type="primary" 
						:loading="calculating" 
						@click="submitForm"
						class="submit-btn"
						icon="el-icon-view"
					>
						方案预览
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 结果展示区域 -->
		<el-card v-if="calculateResult" class="result-card" shadow="never">
			<div class="card-header-title">
				<i class="el-icon-document"></i>
				<span>计算结果</span>
			</div>
			
			<!-- 费用总览 -->
			<div class="result-section">
				<div class="section-title">
					<i class="el-icon-money"></i>
					<span>费用总览</span>
				</div>
				<div class="overview-content">
					<div class="overview-item">
						<div class="item-label">首付租金</div>
						<div class="item-value reward-value">¥ {{ calculateResult.prepayRentPrice }} 元</div>
					</div>
					<div class="overview-item">
						<div class="item-label">服务费率</div>
						<div class="item-value rate-value">{{ calculateResult.netRate }} %</div>
					</div>
					<div class="overview-item">
						<div class="item-label">总租金</div>
						<div class="item-value highlight">¥ {{ calculateResult.rentPrice }} 元</div>
					</div>
				</div>
			</div>

			<!-- 账单详情 -->
			<div class="result-section">
				<div class="section-title">
					<i class="el-icon-tickets"></i>
					<span>账单详情</span>
				</div>
				<div class="bill-content">
					<div
						:class="{ 'bill-item': true, 'pre-pay': bill.isPrepay }"
						v-for="(bill, index) in calculateResult.billList"
						:key="index"
					>
						<div class="bill-label">
							<span>{{ bill.billName }}</span>
							<el-tag v-if="bill.isPrepay" type="info" size="mini" class="prepay-tag">预付</el-tag>
						</div>
						<div class="bill-value" :class="{ 'prepay-value': bill.isPrepay }">
							¥ {{ bill.billPrice }} 元
						</div>
					</div>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getComboList, calculate } from "./api.js";

export default {
	name: "StoreCalculate",

	data() {
		return {
			calculating: false,
			calculateResult: null,
			comboList: [],
			form: {
				salePrice: undefined,
				billNum: undefined,
				storeComboId: undefined,
			},
			rules: {
				salePrice: [
					{ type: "number", required: true, message: "请输入正确的售价" },
				],
				billNum: [
					{ type: "number", required: true, message: "请选择租期" },
				],
				storeComboId: [
					{ type: "number", required: true, message: "请选择方案" },
				],
			},
		};
	},

	computed: {
		billNumOptions() {
			const billNums = [...new Set(this.comboList.map((item) => item.billNum))].sort((a, b) => a - b);
			return billNums.map((num) => ({
				label: `${num}期`,
				value: num,
			}));
		},
		filteredComboOptions() {
			if (!this.form.billNum) return [];
			return this.comboList
				.filter((item) => item.billNum === this.form.billNum)
				.map((item) => ({
					label: `${item.comboName}`,
					value: item.id,
				}));
		},
	},

	async mounted() {
		this.comboList = await getComboList();
	},

	methods: {
		onBillNumChange() {
			this.form.storeComboId = undefined;
		},
        async submitForm() {
            if (!this.$refs.form) return;
            const result = await this.$refs.form.validate();
            if (!result) return;
            try {
                this.calculating = true;
                const response = await calculate({
                    salePrice: this.form.salePrice.toString(),
                    storeComboId: this.form.storeComboId,
                });
                this.$set(this, 'calculateResult', response);
            } catch (error) {
                console.log('error', error)
                throw error;
            } finally {
                this.calculating = false;
            }
        }
    },
};
</script>

<style scoped lang="scss">
.wrapper {
	width: 100%;
	background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
	padding: 20px;
	min-height: calc(100vh - 84px);
	position: relative;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 200px;
		background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
		pointer-events: none;
		z-index: 0;
	}
}

// 页面标题区域
.page-header {
	margin-bottom: 20px;
	position: relative;
	z-index: 1;
	
	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 24px;
		background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
		border-radius: 16px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
		border: 1px solid rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(10px);
	}
	
	.page-title {
		margin: 0;
		font-size: 24px;
		font-weight: 700;
		color: #1a1e25;
		display: flex;
		align-items: center;
		gap: 12px;
		letter-spacing: -0.5px;
		
		.title-icon {
			font-size: 28px;
			background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
		}
	}
}

// 卡片标题样式
.card-header-title {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 16px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 20px;
	padding-bottom: 12px;
	border-bottom: 2px solid #f0f2f5;
	
	i {
		font-size: 18px;
		color: #409EFF;
	}
}

// 表单卡片样式
.form-card {
	margin-bottom: 20px;
	border-radius: 16px;
	border: none;
	background: #ffffff;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	z-index: 1;
	overflow: hidden;
	max-width: 800px;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
	}

	&:hover {
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
	}

	::v-deep .el-card__body {
		padding: 24px 28px;
	}

	.calculate-form {
		.el-form-item {
			margin-bottom: 24px;
			
			.el-form-item__label {
				color: #303133;
				font-weight: 600;
				letter-spacing: 0.3px;
				font-size: 14px;
				position: relative;
				
				&::after {
					content: ':';
					margin-left: 2px;
					color: #909399;
				}
			}
			
			.form-input-number {
				width: 300px;
				
				::v-deep .el-input__inner {
					border-radius: 10px;
					height: 42px;
					line-height: 42px;
					border: 1.5px solid #E4E7ED;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					background: #fafbfc;
					font-size: 14px;
					text-align: left;
					padding-left: 15px;

					&:hover {
						border-color: #C0C4CC;
						background: #ffffff;
					}
					
					&:focus {
						border-color: #409EFF;
						box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
						background: #ffffff;
					}
				}
			}
			
			.form-select {
				width: 300px;
				
				::v-deep .el-input__inner {
					border-radius: 10px;
					height: 42px;
					line-height: 42px;
					border: 1.5px solid #E4E7ED;
					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					background: #fafbfc;
					font-size: 14px;

					&:hover {
						border-color: #C0C4CC;
						background: #ffffff;
					}
					
					&:focus {
						border-color: #409EFF;
						box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
						background: #ffffff;
					}
				}
			}
			
			.form-tip {
				margin-left: 12px;
				font-size: 12px;
				color: #909399;
			}
			
			.submit-btn {
				border-radius: 10px;
				padding: 12px 32px;
				font-weight: 600;
				font-size: 14px;
				background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
				border: none;
				box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				letter-spacing: 0.3px;

				&:hover:not(.is-loading) {
					background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
					box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
					transform: translateY(-2px);
				}

				&:active:not(.is-loading) {
					transform: translateY(0);
					box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
				}
			}
		}
	}
}

// 结果卡片样式
.result-card {
	border-radius: 16px;
	border: none;
	background: #ffffff;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	z-index: 1;
	overflow: hidden;
	max-width: 800px;
	animation: fadeInUp 0.5s ease-out;
	
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
	}

	&:hover {
		box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
	}

	::v-deep .el-card__body {
		padding: 24px 28px;
	}
	
	.result-section {
		margin-bottom: 32px;
		
		&:last-child {
			margin-bottom: 0;
		}
		
		.section-title {
			display: flex;
			align-items: center;
			gap: 8px;
			font-size: 16px;
			font-weight: 600;
			color: #303133;
			margin-bottom: 16px;
			padding-bottom: 12px;
			border-bottom: 2px solid #f0f2f5;
			
			i {
				font-size: 18px;
				color: #409EFF;
			}
		}
		
		.overview-content {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
			gap: 20px;
			
			.overview-item {
				padding: 20px;
				background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
				border-radius: 12px;
				border: 1px solid #e4e7ed;
				transition: all 0.3s ease;
				
				&:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
					border-color: #409EFF;
				}
				
				.item-label {
					font-size: 13px;
					color: #909399;
					margin-bottom: 8px;
					font-weight: 500;
				}
				
				.item-value {
					font-size: 20px;
					font-weight: 700;
					color: #303133;
					
					&.highlight {
						color: #409EFF;
						font-size: 24px;
					}
					
					&.rate-value {
						color: #67C23A;
					}
					
					&.reward-value {
						color: #E6A23C;
					}
				}
			}
		}
		
		.bill-content {
			background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
			border-radius: 12px;
			padding: 16px;
			border: 1px solid #e4e7ed;
			
			.bill-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 14px 16px;
				margin-bottom: 8px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid #e4e7ed;
				transition: all 0.3s ease;
				
				&:last-child {
					margin-bottom: 0;
				}
				
				&:hover {
					border-color: #409EFF;
					box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
					transform: translateX(4px);
				}
				
				&.pre-pay {
					opacity: 0.7;
					background: linear-gradient(135deg, #f5f7fa 0%, #f0f2f5 100%);
					
					.bill-value {
						text-decoration: line-through;
						color: #909399;
					}
				}
				
				.bill-label {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 14px;
					color: #606266;
					font-weight: 500;
					
					.prepay-tag {
						margin: 0;
						border-radius: 4px;
						background: linear-gradient(135deg, #909399 0%, #82848a 100%);
						border: none;
						color: #ffffff;
						font-size: 11px;
						padding: 2px 6px;
					}
				}
				
				.bill-value {
					font-size: 16px;
					font-weight: 600;
					color: #303133;
					
					&.prepay-value {
						color: #909399;
					}
				}
			}
		}
	}
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

// 响应式设计
@media (max-width: 1400px) {
	.form-card,
	.result-card {
		max-width: 100%;
	}
}

@media (max-width: 768px) {
	.wrapper {
		padding: 12px;
	}
	
	.page-header .header-content {
		padding: 16px;
		
		.page-title {
			font-size: 20px;
		}
	}
	
	.form-card,
	.result-card {
		border-radius: 12px;
		
		::v-deep .el-card__body {
			padding: 16px;
		}
	}
	
	.calculate-form {
		.el-form-item {
			.form-input-number,
			.form-select {
				width: 100% !important;
			}
		}
	}
	
	.result-section {
		.overview-content {
			grid-template-columns: 1fr;
		}
	}
}
</style>
